import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=a87f8ffe"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"
import style0 from "./PageNotFound.vue?vue&type=style&index=0&id=a87f8ffe&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a87f8ffe')) {
      api.createRecord('a87f8ffe', component.options)
    } else {
      api.reload('a87f8ffe', component.options)
    }
    module.hot.accept("./PageNotFound.vue?vue&type=template&id=a87f8ffe", function () {
      api.rerender('a87f8ffe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Misc/PageNotFound.vue"
export default component.exports